import type React from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { useUnauthenticatedSignForm } from '#src/app/pages/petitionDetails/shared/hooks';

import { RespondContainer } from '../Respond';

import { SideClosedContainer } from './SideClosed';
import { SideSignedContainer } from './SideSigned';
import { SideUnsignedContainer } from './SideUnsigned';
import { SideVictoryContainer } from './SideVictory';

const SideContainerInner: React.FC<EmptyProps> = () => {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { decisionMaker, signed },
	} = usePetitionDetailsPageUserData();
	const {
		data: { enabled: unauthenticatedSignFormEnabled },
	} = useUnauthenticatedSignForm();

	if (decisionMaker) {
		return <RespondContainer />;
	}
	if (status === 'CLOSED') {
		return <SideClosedContainer />;
	}
	if (status === 'VICTORY') {
		return <SideVictoryContainer />;
	}
	if (signed && !unauthenticatedSignFormEnabled) {
		return <SideSignedContainer />;
	}
	return <SideUnsignedContainer />;
};

type Props = {
	containerRef?: React.RefObject<HTMLDivElement | null>;
};

export const SideContainer: React.FC<Props> = ({ containerRef }) => {
	return (
		<div
			ref={containerRef}
			className="elevation-floating dark:border-stroke-weaker bg-background-base rounded-lg p-8 dark:border"
		>
			<SideContainerInner />
		</div>
	);
};
